
import { useEffect, useState } from 'react';
import { fetchCasualAccess } from './api';

let _access = null;
let _inflight = null;

export const getCasualAccess = (force = false) => {
  if (!force && _access) return Promise.resolve(_access);
  if (!force && _inflight) return _inflight;
  _inflight = fetchCasualAccess(force)
    .then((data) => { _access = data; return data; })
    .catch(() => ({ casual: false }))
    .finally(() => { _inflight = null; });
  return _inflight;
};


export const clearCasualAccess = () => { _access = null; };


export const useCasualAccess = (enabled = true) => {
  const [state, setState] = useState({ loading: enabled && !_access, access: _access });
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    getCasualAccess().then((a) => { if (alive) setState({ loading: false, access: a }); });
    return () => { alive = false; };
  }, [enabled]);
  return state;
};